var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 20V16C52.5 14.9391 52.0786 13.9217 51.3284 13.1716C50.5783 12.4214 49.5609 12 48.5 12H12.5C11.4391 12 10.4217 12.4214 9.67157 13.1716C8.92143 13.9217 8.5 14.9391 8.5 16V48C8.5 49.0609 8.92143 50.0783 9.67157 50.8284C10.4217 51.5786 11.4391 52 12.5 52H48.5C49.5609 52 50.5783 51.5786 51.3284 50.8284C52.0786 50.0783 52.5 49.0609 52.5 48V44",
    stroke: "#757575",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 20H54.5C55.0304 20 55.5391 20.2107 55.9142 20.5858C56.2893 20.9609 56.5 21.4696 56.5 22V42C56.5 42.5304 56.2893 43.0391 55.9142 43.4142C55.5391 43.7893 55.0304 44 54.5 44H36.5C33.3174 44 30.2652 42.7357 28.0147 40.4853C25.7643 38.2348 24.5 35.1826 24.5 32C24.5 28.8174 25.7643 25.7652 28.0147 23.5147C30.2652 21.2643 33.3174 20 36.5 20Z",
    stroke: "#757575",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 36C38.7091 36 40.5 34.2091 40.5 32C40.5 29.7909 38.7091 28 36.5 28C34.2909 28 32.5 29.7909 32.5 32C32.5 34.2091 34.2909 36 36.5 36Z",
    stroke: "#757575",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.79d6dba605246afd301e42c2e9d18cd5.svg";
export { ForwardRef as ReactComponent };